import { Job, JobCategory, JobQuery } from "@interfaces/career"
import { createContext, ReactNode, useContext, useEffect, useState } from "react"
import JobsServices from "@services/jobs.services"
import { useRouter } from "next/router"

export interface JobsContextProps {
  isLoading: boolean
  setIsLoading: (value: boolean) => void
  jobs: Job[]
}

const initialState: JobsContextProps = {
  isLoading: false,
  jobs: [],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setIsLoading: (value) => {},
}

const JobsContext = createContext<JobsContextProps>(initialState)

interface JobsProviderProps {
  children: ReactNode
  initialJobs: Job[]
}

export const JobsProvider = ({ children, initialJobs }: JobsProviderProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const [jobs, setJobs] = useState<Job[]>(initialJobs)

  const job = new JobsServices()
  const router = useRouter()
  const query = router.query

  useEffect(() => {
    const queries: Partial<JobQuery> = {
      ...(query.type && { type: query.type as string }),
      ...(query.search && { search: query.search as string }),
      ...(query.slug && { category: query.slug as string }),
    }

    const getData = async () => {
      try {
        const res = await job.getJobsList(queries)

        if (res.isSuccess) {
          const result = res.getValue()
          const data = result.data

          setJobs(data)
        }

        setIsLoading(false)
      } catch (e: any) {
        console.log(e)
      }
    }

    getData()
  }, [query])

  return (
    <JobsContext.Provider value={{ isLoading, setIsLoading, jobs }}>
      {children}
    </JobsContext.Provider>
  )
}

export const useJobs = () => useContext(JobsContext)
